module.exports = __webpack_public_path__ + "img/gtensor-logo.2418aab0.png";